/**
 * True when every stack frame is a browser-extension script - almost certainly a
 * third-party extension (Urban VPN, 1ClickVPN, etc.), since ours never runs on our site.
 *
 * Self-contained and legacy-safe (no arrow fns, no `??`) so `.toString()` can inline it
 * into a server-rendered snippet.
 */
// eslint-disable-next-line func-style -- a declaration keeps .toString() output stable
export function isExtensionOnlyStackTrace(frameUrls: Array<string | null | undefined> | null | undefined): boolean {
    if (!frameUrls || frameUrls.length === 0) return false;

    for (let i = 0; i < frameUrls.length; i++) {
        const url = frameUrls[i] || '';

        if (!/^[a-z-]+-extension:\/\//i.test(url)) return false;
    }

    return true;
}
